import { autorun } from "mobx";
import AttributeStore from "./AttributeStore";

/**
 * @class DataStore
 * Wird zu beginn erstellt, erstellt für jedes einzelne Attribut einen AttributeStore, der dessen State handled
 *
 */
class DataStore {
  constructor() {
    this.attributeValues = {};
  }

  startUp(
    themesConfig = {},
    handler = {},
    requestStore,
    saveKey,
    map,
    registerDataStore
  ) {
    const { themes } = themesConfig;
    this.saveKey = saveKey;
    this.onHandlerSet = [];
    this.setHandler(handler);
    this.requestStore = requestStore;
    this.initAttributeValues(themes);
    this.registerDataStore = registerDataStore;
    this.map = map;
    this.requestStore.parameterStore.registerStore(
      this,
      "attributeEdit",
      "attributeValues",
      "value"
    );
    this.requestStore.parameterStore.registerSubstore(
      this,
      "geometryChanges",
      "geometryChanges"
    );
    this.registerDataStore?.registerStore(
      this,
      "attributeEdit",
      "attributeValues",
      "value",
      "setValue"
    );
    return this;
  }

  setHandler(handler) {
    if (handler.store) this.externStore = handler.store;
    if (handler.messageHandler) this.messageHandler = handler.messageHandler;
    if (handler.dataHandler) this.dataHandler = handler.dataHandler;
    if (handler.requestHandler) this.requestHandler = handler.requestHandler;
    if (handler.dependencyHandler)
      this.dependencyHandler = handler.dependencyHandler;
    if (handler.saveChangesHandler)
      this.saveChangesHandler = handler.saveChangesHandler;
    this.onHandlerSet.forEach((f) => f());
  }

  getHandler() {
    const handler = {
      messageHandler: this.messageHandler,
      dataHandler: this.dataHandler,
      requestHandler: this.requestHandler,
      dependencyHandler: this.DependencyHandler,
      saveChangesHandler: this.saveChangesHandler,
    };
    return handler;
  }

  addAttribute(attribute) {
    if (this.attributeValues[attribute.id] === undefined)
      this.attributeValues[attribute.id] = new AttributeStore(
        attribute,
        this.getHandler(),
        this
      );
    this.requestStore.parameterStore.registerSubstore(
      this.attributeValues[attribute.id],
      "value",
      attribute.id
    );
  }

  getInitialConfig() {
    return this.attributeConfigs;
  }

  /**
   * Wer auch immer das irgendwann debiuggen muss: Es tut mir Leid!
   * Funktion, welche eine ConfigSource auf Ersetzungstrungs durhcsucht (z.b. $test$) und auf das jeweilige Attribute im Store eine Reaction packt
   * Und die configTarget bei änderung des Attributs im Store anpasst, damit diese Dann im modul wieder aktuell angezeigt wird
   * Dazu Da, um bspw. Änderungen "von außen" zu berücksichtigen, auch in Anfragen an Server für
   * @param {JSON} configSource
   * @param {JSON} configTarget
   * @param {String} escapeSymbol
   * @param {ReactModul} modul
   */
  setUpReactionExternInfo(configSource, configTarget, escapeSymbol, modul) {
    if (this.externStore) {
      const keys = Object.keys(configSource);
      keys.forEach((key) => {
        const valueSource = configSource[key];
        const valueTarget = configTarget[key];
        const update = function (newVal) {
          configTarget[key] = newVal;
          modul.setState({
            currentConfig: this.targetConfig,
          });
        };
        if (typeof valueSource === "string")
          this.setUpReactionFromExternStoreForString(
            escapeSymbol,
            valueSource,
            update.bind(modul)
          );
        if (typeof valueSource === "object") {
          this.setUpReactionExternInfo(
            valueSource,
            valueTarget,
            escapeSymbol,
            modul
          );
        }
      });
    }
  }

  setUpReactionFromExternStoreForString(
    escapeSymbol,
    string,
    reactionFunction
  ) {
    const allIndicesOf = function (str, char) {
      const indices = [];
      for (let i = 0; i < str.length; i++) {
        if (str[i] === char) indices.push(i);
      }
      return indices;
    };
    const getAttributeFromString = function (str, escapeChar) {
      const indices = allIndicesOf(str, escapeChar);
      const attributes = [];
      let i = 0;
      while (i + 1 < indices.length) {
        const ind1 = indices[i];
        const ind2 = indices[i + 1];
        attributes.push(str.substring(ind1 + 1, ind2));
        i += 2;
      }
      return attributes;
    };
    if (typeof string === typeof "test" && string.includes(escapeSymbol)) {
      const externAttributes = getAttributeFromString(string, escapeSymbol);
      autorun(() => {
        let replacedString = string;
        externAttributes.forEach((attr) => {
          replacedString = replacedString.replace(
            escapeSymbol + attr + escapeSymbol,
            this.externStore[attr]
          );
        });
        reactionFunction(replacedString);
        this.messageHandler.logDebug(`updated ${string} -> ${replacedString}`);
      });
    }
  }

  /**
   * @function
   * Inittiialsisiert die Stores für alle Attribute.
   * Dabei werden verschachtelte Attribute (wie SliderGroups) rekursiv durchlaufen,
   * um die AttributeStores zu erstellen
   * @name DataStore.initAttributeValues
   *
   * @param {*} themes
   */
  initAttributeValues(themes) {
    const attributeIds = [];
    const attributeConfigs = [].concat.apply(
      [],
      themes.filter((t) => t.title !== "editToolbar").map((t) => t.attributes)
    );
    this.attributeConfigs = attributeConfigs;
    // this.attributeValues = {};
    const initSubAttributeValues = (parent, subs = []) => {
      initParentAttributeValues(subs);
      const parentAttributeData = new AttributeStore(
        parent,
        this.getHandler(),
        this,
        subs.map((s) => s.id)
      );
      this.attributeValues[parent.id] = parentAttributeData;
    };

    const initParentAttributeValues = (configs = []) => {
      configs
        .filter((attribute) => attribute.type === "attributeCollection ")
        .forEach((attribute) =>
          initSubAttributeValues(
            attribute,
            attribute.attributeOption.attributes
          )
        );
      configs
        .filter((attribute) => attribute.type === "sliderGroup")
        .forEach((attribute) => {
          initSubAttributeValues(attribute, attribute.attributeOption.slider);
          this.attributeValues[`${attribute.id}sub`] =
            this.attributeValues[attribute.id];
        });
      const attributeDataSub = [];
      configs.forEach((attribute) => {
        attributeIds.push(attribute.id);
        if (this.attributeValues[attribute.id] === undefined) {
          this.attributeValues[attribute.id] = new AttributeStore(
            attribute,
            this.getHandler(),
            this
          );
        } else {
          this.attributeValues[attribute.id].reset(attribute);
        }
        attributeDataSub[attribute.id] = this.attributeValues[attribute.id];
      });
      return attributeDataSub;
    };

    initParentAttributeValues(attributeConfigs);
  }
}

export default new DataStore();
